import { Collection } from "kreate-common/modules/business-types";

import { EM_DASH } from "@/modules/common-utils/unicode";

export function getPageTitle(collection: Collection | null | undefined) {
  return [
    collection?.title || EM_DASH,
    collection?.populated?.createdBy.displayName || "Kreate",
  ].join(" | ");
}
